<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "BusinessPartner"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/BusinessPartner.vue